/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useMemo } from "react";
import { clinicIcons } from "../../../components/Icons";
import { formatClinicAddress } from "../../../utils/addressUtils";
import AccordionCard from "./AccordionCard";

const Location = ({ clinicInfo }) => {
	const fullAddress = useMemo(
		() => (clinicInfo ? formatClinicAddress(clinicInfo) : ''),
		[clinicInfo]
	);

	// If we don't have an address, don't render the component
	if (!fullAddress) {
		return null;
	}

	return (
		<AccordionCard title="Location">
			<iframe
				src={`https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`}
				height="280"
				className="w-full rounded-lg border-none mb-6"
			></iframe>
			<div className="text-sm text-black flex items-center gap-3">
				{clinicIcons.mapmarker}
				<div className="w-0 flex-grow">
					{fullAddress}
				</div>
			</div>
		</AccordionCard>
	);
};
export default Location;
